// removed by extract-text-webpack-plugin
module.exports = {"birthday":"birthday_3R9ej","go":"go_3muoB","back":"back_3gXWw"};


//////////////////
// WEBPACK FOOTER
// ./app/components/child/styles.scss
// module id = 423
// module chunks = 1